'use strict';
var React = require('react');

class UserMenuComponentTemplate extends React.Component {
    renderName() {
        let src = null;
        if (src == null) {
            var mediaCount = this.props.user.Media ? this.props.user.Media.length : 0;
            if (mediaCount >= 1 && typeof this.props.user.Media[mediaCount - 1] != 'undefined') {
                src = this.props.user.Media[mediaCount - 1].MediaUrl;
            }
        }

        if (src === null) {
            src = '/assets/images/blank.png';
        }
        if (this.props.user.DisplayName) {
            return (
                <div id="profile-img-header-container">
                    <img alt="" src={src} className="media-url-container" id="profile-img-header"></img>
                    <p id="name-user-header">{this.props.user.DisplayName.substring(0, 15)}</p>
                </div>
                
            )
        }

        return (
            <p>{(this.props.user.UserName || '').substring(0, 15)}</p>
        )
    }

    renderSettings() {
        if (typeof this.props.user.Roles !== 'undefined' && this.props.user.Roles != null && (this.props.user.Roles.includes('Merchant') || this.props.user.Roles.includes('Submerchant'))) {
            return (
                <li><a href="/merchants/settings">Mi perfil</a></li>
            )
        }

        return (
            <li><a href="/users/settings">Mi perfil</a></li>    
        )
    }

    renderChatField() {
        if (typeof this.props.user.Roles !== 'undefined' && this.props.user.Roles != null && (this.props.user.Roles.includes('Merchant') || this.props.user.Roles.includes('Submerchant'))) {
            return (
                <li><a href="/chat/inbox">Mensajes privados</a></li>
            )
        }
    }

    showUserMenu(event) {
        event.stopPropagation();
        $('.h-username').find(".h-dd-menu").slideToggle();
        $(".h-st-menus").hide();
        $(".h-cart .h-cart-menu").hide();
        $(".h-more .h-dd-menu").hide();
        $(".h-user .h-dd-menu").hide();
    }

    renderChangePasswordMenu() {
        let showChangepassword = false;
        if (this.props.user) {
            if (this.props.user.UserName && !(this.props.user.UserName.startsWith('Facebook') || this.props.user.UserName.startsWith('Google'))) {
                showChangepassword = true;
            }
            else if (this.props.user.UserLogins && this.props.user.UserLogins.length > 0) {
                const loginProviders = this.props.user.UserLogins.map(l => l.LoginProvider);
                showChangepassword = !loginProviders.includes('Facebook') && !loginProviders.includes('Google');
            }
        }

        if (showChangepassword) {
            return (<li><a href="/accounts/change-password">Cambiar contraseña head</a></li>);
        }
        return;
    }

    getRedirectLink() {
      //  if (typeof this.props.user.Roles !== 'undefined' && this.props.user.Roles != null && (this.props.user.Roles.includes('Merchant') || this.props.user.Roles.includes('Submerchant'))) {
      //      if (process.env.CHECKOUT_FLOW_TYPE == 'b2c') return "/merchants/order/history";
       //     return "/quotation/list";
       // }
        //if (process.env.CHECKOUT_FLOW_TYPE == 'b2c') return "/purchase/history";
        //return "/quotation/list?buyer=true";
        return "/purchase/history";
    }

    render() {
        if (typeof this.props.user !== 'undefined' && this.props.user != null && this.props.user.Guest === false) {
            const self = this;
            const userDetail = self.props.user;
            var usuarioConsulta = 'NO';
            var tipoCliente = 'B2B';
            if(userDetail) {
                if(userDetail.CustomFields) {
                    if(userDetail.CustomFields.find(x => x.Name == "Cliente de Consulta")) {
                        usuarioConsulta  = userDetail.CustomFields.find(x => x.Name == "Cliente de Consulta").Values[0];
                    }
                    if(userDetail.CustomFields.find(x => x.Name == "Tipo de Usuario")) {
                        tipoCliente  = userDetail.CustomFields.find(x => x.Name == "Tipo de Usuario").Values[0];
                    }
                }
            }          
            
            var renderMenu;
            return (
                <li className="h-username" onClick={(e) => this.showUserMenu(e)}>
                    <span>
                        {this.renderName()}
                        <i className="fa fa-angle-down"></i>
                    </span>
                    <ul className="h-dd-menu hide-me">
                        {this.renderSettings()}
                        {this.renderChatField()}
                        <li><a href={this.getRedirectLink()}>Mis pedidos</a></li>  
                        <li className="h-username1"><a href=""></a></li>
                        {/* {
                            tipoCliente==='B2C' ?
                            <li><a href="/chatinbox">Mensajes privados</a></li>
                            : false
                        } */}                     
                            {tipoCliente ==='B2C' ? (
                                <li><a href="/chat/inbox">Mensajes privados</a></li>
                            ) : (
                                <li><a href="/backorders/">Backorders</a></li>
                            )}
                        <li><a href="/accounts/change-password">Cambiar contraseña</a></li>   
                        {/*this.renderChangePasswordMenu()*/}
                        <form action="/accounts/sign-out" method="post" style={{ cursor: 'pointer'}}>
                            <li><a id="signout-form" onClick={(e) => this.props.signOut(e)}>Cerrar sesión</a></li>
                        </form>
                    </ul>
                    <input type="hidden" id="clientType" value={tipoCliente} />
                </li>
            );

            // if(usuarioConsulta == 'NO'){
            //     return(
            //         <li className="h-username" onClick={(e) => this.showUserMenu(e)}>
            //             <span>
            //                 {this.renderName()}
            //                 <i id="angle-down-username" className="fa fa-angle-down"></i>
            //             </span>
            //             <ul className="h-dd-menu hide-me">
            //                 {this.renderSettings()}
            //                 <li><a href={this.getRedirectLink()}>Mis pedidos</a></li>                                                
            //                 {
            //                     tipoCliente==='B2B' ?
            //                     <li><a href="/backorders/">Backorders</a></li>
            //                     : false
            //                 }
            //                 {
            //                     tipoCliente==='B2C' ?
            //                     <li><a href="/chatinbox">Mensajes privados</a></li>
            //                     : false
            //                 }
            //                 <li><a href="/accounts/change-password">Cambiar contraseña</a></li>
            //                 {/*this.renderChangePasswordMenu()*/}
            //                 <form action="/accounts/sign-out" method="post" style={{ cursor: 'pointer'}}>
            //                     <li><a id="signout-form" onClick={(e) => this.props.signOut(e)}>Cerrar sesión</a></li>
            //                 </form>
            //             </ul>
            //         </li>
            //     );
            // }else{
            //     return (
            //         <li className="h-username" onClick={(e) => this.showUserMenu(e)}>
            //             <span>
            //                 {this.renderName()}
            //                 <i className="fa fa-angle-down"></i>
            //             </span>
            //             <ul className="h-dd-menu hide-me">
            //                 {this.renderSettings()}
            //                 <li class="h-username1"><a href=""></a></li>
            //                 <li><a href="/accounts/change-password">Cambiar contraseña</a></li>
            //                 <li><a href="/chat/inbox">Mensajes privados</a></li>
            //                 {/*this.renderChangePasswordMenu()*/}
            //                 <form action="/accounts/sign-out" method="post" style={{ cursor: 'pointer'}}>
            //                     <li><a id="signout-form" onClick={(e) => this.props.signOut(e)}>Cerrar sesión</a></li>
            //                 </form>
            //             </ul>
            //             <input type="hidden" id="clientType" value={tipoCliente} />
            //         </li>
            //     );
            // }
        } else {
            var tipoCliente = 'B2B';
            function getLoginUrl() {
                let search = location.search;
                if (search) {
                    search = search.replace('?error=invalid-token', '');
                }

                let loc = (location.pathname + search).substr(1);
                return `/accounts/non-private/sign-in?returnUrl=${loc}`
            }

            return (
                <>
                    <li className="h-username">
                        <a href={getLoginUrl()}>Iniciar sesión/Crear cuenta</a>
                    </li>                
                    <input type="hidden" id="clientType" value={tipoCliente} />
                </>
            );
        }
    }
}

module.exports = UserMenuComponentTemplate;
